// extracted by mini-css-extract-plugin
export default {"wrapper":"TabButton_wrapper__Y3bc6","btn":"TabButton_btn__ZzLCp","active":"TabButton_active__KHV-Q"};